import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getLocation } from "./globals/getLocation";
export var splitHostname = function(hostname) {
    var urlParts = /([a-z-0-9]{2,63}).([a-z.]{2,5})$/.exec(hostname);
    if (!urlParts) {
        return;
    }
    var _urlParts = _sliced_to_array(urlParts, 3), domain = _urlParts[1], type = _urlParts[2];
    var subdomain = hostname === "localhost" ? undefined : hostname.replace("".concat(domain, ".").concat(type), "").slice(0, -1);
    return {
        domain: domain !== null && domain !== void 0 ? domain : "",
        type: type !== null && type !== void 0 ? type : "",
        subdomain: !subdomain ? undefined : subdomain
    };
};
/**
 * This function is used to mock the current origin on unit tests
 * @returns The current value for location.origin
 */ export var getLocationOrigin = function() {
    var _getLocation;
    return (_getLocation = getLocation()) === null || _getLocation === void 0 ? void 0 : _getLocation.origin;
};
